import { useField } from 'formik'
import React, { useRef } from 'react'
import { toBase64 } from '../../helpers/base64'
import ErrorIcon from '../icons/ErrorIcon'

const FormFileUpload = ({ handle, name, required }) => {
  const ref = useRef()
  const [{ value }, { error, touched }, { setValue }] = useField(handle)

  const handleFileSelected = async e => {
    const files = e.target.files

    const newFiles = []
    for (let i = 0; i < files.length; i++) {
      const encoded = await toBase64(files[i])
      newFiles.push({
        fileData: encoded,
        filename: files[i].name,
      })
    }

    setValue([...value, ...newFiles])
  }

  return (
    <div className="mb-8">
      <div>
        {value?.length > 0 && (
          <div
            className={`mb-5 border divide-y rounded ${
              error && touched
                ? 'border-red divide-red'
                : 'border-black divide-black'
            }`}
          >
            {value.map(file => (
              <div key={file.filename} className="relative">
                <div className="px-5 py-3.5 u-navi font-bold text-base flex items-center justify-between">
                  <div>{file.filename}</div>
                  <button
                    type="button"
                    onClick={() =>
                      setValue(value.filter(f => f.filename !== file.filename))
                    }
                    className={error && touched ? 'mr-8' : 'mr-0'}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="22"
                      height="22"
                      fill="none"
                      viewBox="0 0 22 22"
                    >
                      <path
                        fill="#000"
                        d="M5 6h12v12a2 2 0 01-2 2H7a2 2 0 01-2-2V6z"
                      ></path>
                      <rect
                        width="14"
                        height="2"
                        x="4"
                        y="3"
                        fill="#000"
                        rx="1"
                      ></rect>
                      <rect
                        width="4"
                        height="4"
                        x="9"
                        y="1"
                        fill="#000"
                        rx="2"
                      ></rect>
                      <rect
                        width="2"
                        height="8"
                        x="8"
                        y="9"
                        fill="#fff"
                        rx="1"
                      ></rect>
                      <rect
                        width="2"
                        height="8"
                        x="12"
                        y="9"
                        fill="#fff"
                        rx="1"
                      ></rect>
                    </svg>
                  </button>
                </div>

                {error && touched && (
                  <ErrorIcon className="absolute z-20 top-[10px] right-2" />
                )}
              </div>
            ))}
          </div>
        )}

        <button
          type="button"
          className="u-btn"
          onClick={() => ref.current?.click()}
        >
          {name}
        </button>

        <input
          ref={ref}
          id={handle}
          name={handle}
          type="file"
          className="w-0 h-0 opacity-0 text-[0px] pointer-events-none absolute -z-1"
          onChange={handleFileSelected}
          multiple
        />
      </div>
    </div>
  )
}

export default FormFileUpload
